import React from "react";

const SurveyEditHeader = ({ survey }) => {
  const points = survey.points || null;

  return (
    <div className="EditSurveyHeader clearfix">
      <div className="col-md-12">
        <h1 className="title">
          {survey.title}
          {points && <span className="pts">+{points}</span>}
        </h1>
      </div>
    </div>
  );
};

export default SurveyEditHeader;
